import LayoutSetLevelZero from 'components/ui/layout-set/general/layout-set-level-zero';

import PageAllergensList from 'components/pages/professional/workspace/allergens/list/page-allergens-list';
import ButtonCreateNewAllergen from 'components/pages/professional/workspace/allergens/list/cmpt-button-create-new-allergen';

import PageAllergenCred from 'components/pages/professional/workspace/allergens/cred-allergen/page-allergen-cred';

export default [
  {
    path: '/professional/workspace/allergens',
    component: LayoutSetLevelZero,
    props: {
      index: true,
    },
    children: [
      {
        path: '',
        name: 'allergens-list',
        components: {
          default: PageAllergensList,
          collapsedMenuTop: ButtonCreateNewAllergen,
        },
        meta: {
          auth: true,
        },
        props: {
          default: route => ({
            page: Number(route.query.page),
            meta: {
              navigation: {
                edit: 'allergen-details',
              },
            },
          }),
          collapsedMenuTop: {
            title: 'label.create_new_allergen',
            link: 'allergen-search',
          },
        },
        children: [
          {
            path: 'add',
            meta: { auth: true },
            name: 'add-allergen',
            component: PageAllergenCred,
            props: {
              meta: {
                title: 'label.add_new_allergen',
                navigation: {
                  cancel: 'allergens-list',
                  success: 'allergens-list',
                },
              },
            },
          },
          {
            path: ':id(\\d+)/details',
            meta: { auth: true },
            name: 'allergen-details',
            component: PageAllergenCred,
            props: route => ({
              id: route.params.id,
              meta: {
                title: 'label.allergen_details',
                navigation: {
                  cancel: 'allergens-list',
                  success: 'allergens-list',
                },
              },
            }),
          },
        ],
        // end ~ children
      },
    ],
  }, // end ~ path: '/workspace/allergens',
];



// WEBPACK FOOTER //
// ./src/router/professional/workspace/router-allergens.js